import { observer } from 'mobx-react-lite';
import styles from './FullScreenSpinner.module.css';
import Spinner from './Spinner';

function FullScreenSpinner() {
    return (
        <div className={styles.container}>
            <Spinner />
        </div>
    );
}

export default observer(FullScreenSpinner);